import { get, set } from 'lodash';
export function getValue(obj, key) {
  return get(obj, key);
}
export function setValue(obj, key, value) {
  return set(obj, key, value);
}